import Page from '../components/Page'
import Section from '../components/Section'
import PrimaryTitle from '../components/PrimaryTitle'
import ContactForm from '../components/ContactForm'

const pageTitle = 'Ihr Anliegen zu Virtual-Reality-Therapie'

const form = {
  title: 'Kontakt',
}

export default function Contact() {
  return (
    <Page title={pageTitle}>
      <Section>
        <PrimaryTitle center title={form.title}></PrimaryTitle>
        <ContactForm />
      </Section>
    </Page>
  )
}
